const origin = {
  production: "https://api.axondc.ir",
  development: "https://api.axondc.ir",
  development1: "http://localhost:4000",
};

export const hostname = origin[process.env.NODE_ENV];

export const base_url = `${hostname}`;
